'use strict';

module.exports = require('rc-pagination/lib/locale/zh_CN');


/*****************
 ** WEBPACK FOOTER
 ** ./components/basic/pagination/locale/zh_CN.js
 ** module id = 405
 ** module chunks = 0
 **/